export const environment = {
  api_url: "https://api.ultracondominio.com.br/api/"
};
